import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { BaseConfirmation } from '../components/base-confirmation/component.js';

var styles = {"container":"confirmation__container_78z0a"};
require('./mobile.css')

var ConfirmationMobile = function (_a) {
    var className = _a.className, resProps = __rest(_a, ["className"]);
    return (React.createElement(BaseConfirmation, __assign({ mobile: true, className: cn(className, styles.container) }, resProps)));
};

export { ConfirmationMobile };
